import decomptesClient from "../client";

const getListDecomptes = async (token, data) => {

    try {
        const headers = {
            'content-type': 'application/json',
            'authorization': `Bearer ${token}`
        };

        const options = {
            headers: headers,
            searchParams: data
        }

        return await decomptesClient.get("", options).json();

    } catch (error) {
        console.error('Error call ws getListDecomptes:', error);
        if (error.name === 'HTTPError') {
            return await error.response.json();
        }
    }

}
const getDecompteDetails = async (token, id) => {

    try {
        const headers = {
            'content-type': 'application/json',
            'authorization': `Bearer ${token}`
        };

        const options = {
            headers: headers,
        }

        return await decomptesClient.get(`details/${id}`, options).json();

    } catch (error) {
        console.error('Error call ws getListDecomptes:', error);
        if (error.name === 'HTTPError') {
            return await error.response.json();
        }
    }

}

export default {
    getListDecomptes,
    getDecompteDetails
}